import * as yup from 'yup';

function email(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'EMAIL_FIELD_FORMAT_EMAIL',
        defaultMessage: 'Email must be a valid email address',
      }),
    )
    .test(
      'has-tld',
      formatMessage({
        id: 'EMAIL_FIELD_FORMAT_TLD',
        defaultMessage: 'Email must have a valid top-level domain',
      }),
      value => {
        return value
          ? /\.[a-zA-Z]{2,}$/.test(value.split('@')[1] || '')
          : false;
      },
    )
    .required(
      formatMessage({
        id: 'CREATEFORM_EMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Email is required',
      }),
    );
}

function firstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_FIRST_NAME_FIELD_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function lastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_LAST_NAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function enabled(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function role(formatMessage) {
  return yup.object().required(
    formatMessage({
      id: 'CREATEFORM_ROLE_FIELD_IS_REQUIRED',
      defaultMessage: 'Role is required',
    }),
  );
}

function customerNewPassword(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_NEWPASSWORD_FIELD_IS_REQUIRED',
      defaultMessage: 'Password is required',
    }),
  );
}

function customerRetypePassword(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_RETYPEPASSWORD_FIELD_IS_REQUIRED',
        defaultMessage: 'Please confirm your password',
      }),
    )
    .oneOf(
      [yup.ref('customerNewPassword'), null],
      formatMessage({
        id: 'CREATEFORM_RETYPEPASSWORD_MATCH',
        defaultMessage: 'Passwords must match',
      }),
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      email: email(formatMessage),
      firstName: firstName(formatMessage),
      lastName: lastName(formatMessage),
      enabled: enabled(formatMessage),
      role: role(formatMessage),
      customerNewPassword: customerNewPassword(formatMessage),
      customerRetypePassword: customerRetypePassword(formatMessage),
    })
    .required();

export default validationSchema;
